export default "__VITE_ASSET__DXxL0y8d__"